/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AcknowledgeRiskPolicyChallengeRequestBody,
  AcknowledgeRiskPolicyChallengeRequestBody$Outbound,
  AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
} from "../components/acknowledgeriskpolicychallengerequestbody.js";

export type DeclineRiskPolicyChallengeSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeclineRiskPolicyChallengeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  acknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody;
};

/** @internal */
export type DeclineRiskPolicyChallengeSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeclineRiskPolicyChallengeSecurity$outboundSchema: z.ZodMiniType<
  DeclineRiskPolicyChallengeSecurity$Outbound,
  DeclineRiskPolicyChallengeSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function declineRiskPolicyChallengeSecurityToJSON(
  declineRiskPolicyChallengeSecurity: DeclineRiskPolicyChallengeSecurity,
): string {
  return JSON.stringify(
    DeclineRiskPolicyChallengeSecurity$outboundSchema.parse(
      declineRiskPolicyChallengeSecurity,
    ),
  );
}

/** @internal */
export type DeclineRiskPolicyChallengeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AcknowledgeRiskPolicyChallengeRequestBody:
    AcknowledgeRiskPolicyChallengeRequestBody$Outbound;
};

/** @internal */
export const DeclineRiskPolicyChallengeRequest$outboundSchema: z.ZodMiniType<
  DeclineRiskPolicyChallengeRequest$Outbound,
  DeclineRiskPolicyChallengeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    acknowledgeRiskPolicyChallengeRequestBody:
      AcknowledgeRiskPolicyChallengeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      acknowledgeRiskPolicyChallengeRequestBody:
        "AcknowledgeRiskPolicyChallengeRequestBody",
    });
  }),
);

export function declineRiskPolicyChallengeRequestToJSON(
  declineRiskPolicyChallengeRequest: DeclineRiskPolicyChallengeRequest,
): string {
  return JSON.stringify(
    DeclineRiskPolicyChallengeRequest$outboundSchema.parse(
      declineRiskPolicyChallengeRequest,
    ),
  );
}
